// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Stack, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

interface Props {
  /**
   * The padding top of the container
   */
  paddingTop?: number;
}

/**
 * A container for table controls that uses a sticky position to stay at the top
 * of the viewport. For extra small (xs) screens, the controls are stacked
 * vertically. For small (sm) screens and larger, the controls are stacked
 * horizontally.
 */
export function TableControlContainer(props: PropsWithChildren<Props>) {
  const theme = useTheme();

  return (
    <Stack
      useFlexGap
      top={0}
      zIndex={theme.zIndex.fab}
      spacing={2}
      paddingTop={props.paddingTop ?? 2}
      position="sticky"
      paddingBottom="16px"
      direction={{ xs: 'column', sm: 'row' }}
      sx={{
        backgroundImage:
          'linear-gradient(rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) calc(100% - 16px), rgba(255, 255, 255, 0) 100%)',
      }}
    >
      {props.children}
    </Stack>
  );
}
